<template>
  <loader :data="blocks">
    <table-component :data="blocks" sort-by="height" sort-order="desc" :show-filter="false" :show-caption="false" table-class="w-full">
      <table-column show="id" :label="$t('ID')" header-class="left-header-start-cell" cell-class="left-start-cell">
        <template slot-scope="row">
          <link-block :id="row.id"></link-block>
        </template>
      </table-column>

      <table-column show="height" :label="$t('Height')" header-class="left-header-cell hidden md:table-cell" cell-class="left-cell hidden md:table-cell">
        <template slot-scope="row">
          {{ row.height }}
        </template>
      </table-column>

      <table-column show="timestamp" :label="$t('Timestamp')" header-class="left-header-cell" cell-class="left-cell">
        <template slot-scope="row">
          {{ readableTimestamp(row.timestamp) }}
        </template>
      </table-column>

      <table-column show="numberOfTransactions" :label="$t('Transactions')" header-class="right-header-cell hidden md:table-cell" cell-class="right-header-cell hidden md:table-cell border-none">
        <template slot-scope="row">
          {{ row.numberOfTransactions }}
        </template>
      </table-column>

      <table-column show="generatorPublicKey" :label="$t('Generated by')" header-class="right-header-cell hidden lg:table-cell" cell-class="right-cell hidden lg:table-cell">
        <template slot-scope="row">
          <link-wallet :public-key="row.generatorPublicKey"></link-wallet>
        </template>
      </table-column>

      <table-column show="totalForged" :label="$t('Reward (token)', { token: networkToken() })" header-class="right-header-cell" cell-class="right-cell">
        <template slot-scope="row">
          {{ readableCrypto(row.totalForged) }}
        </template>
      </table-column>

      <table-column show="totalFee" :label="$t('Fee (token)', {token: networkToken()})" header-class="right-header-end-cell" cell-class="right-end-cell">
        <template slot-scope="row">
          {{ readableCrypto(row.totalFee) }}
        </template>
      </table-column>
    </table-component>
  </loader>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    blocks: {
      type: Array,
      required: true,
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tables/Blocks.vue